// app selectors
export const getAboutContent = content => content.pages.about
export const getLecturesContent = content => content.pages.lectures
export const getWorkshopsContent = content => content.pages.workshops
export const getSponsorsContent = content => content.pages.sponsors
export const getVenueContent = content => content.pages.venue
export const getInformationContent = content => content.pages.information
export const getStandsContent = content => content.pages.stands
export const getPresentations = content =>
  Object.values(content.data.presentations)
export const getTracks = content => Object.values(content.data.tracks)
export const getSessions = content => content.data.sessions
export const getNavigationLabels = content => content.navigation.labels
export const getAppTitle = content => content.general.appTitle
export const getPresentation = (content, id) => content.data.presentations[id]
export const getTrack = (content, id) => content.data.tracks[id]
export const getMessages = content => content.intl.messages
export const getPreferredLocales = content => content.intl.preferredLocales
export const getFeedbackCfg = content => content.addons.feedback.cfg
export const getFeedbackDefinition = (content, type) =>
  content.addons.feedback.definitions[type]
export const getSocialShareDefinition = (content, type) =>
  content.addons.socialShare.definitions[type]
export const getTheme = content => content.theme
export const getChatCfg = content => content.addons.chat.cfg
export const getPresentationChatroom = (content, pid) =>
  content.addons.chat.definitions['presentation'].rooms[pid]
export const getGlobalChatroom = (content, pid) =>
  content.addons.chat.definitions['global'].room
export const getChatAdminUser = (content, key) =>
  content.addons.chat.admins.find(a => a.urlKey === key)



// WEBPACK FOOTER //
// ./src/app/selectors.js